import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { MarketdateMeterreading } from './marketdate-meterreading.model';
import { MarketdateMeterreadingService } from './marketdate-meterreading.service';

@Component({
    selector: 'jhi-marketdate-meterreading-detail',
    templateUrl: './marketdate-meterreading-detail.component.html'
})
export class MarketdateMeterreadingDetailComponent implements OnInit, OnDestroy {

    marketdateMeterreading: MarketdateMeterreading;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private marketdateMeterreadingService: MarketdateMeterreadingService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['marketdateMeterreading', 'timestampType']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInMarketdateMeterreadings();
    }

    load(id) {
        this.marketdateMeterreadingService.find(id).subscribe((marketdateMeterreading) => {
            this.marketdateMeterreading = marketdateMeterreading;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInMarketdateMeterreadings() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateMeterreadingListModification', (response) => this.load(this.marketdateMeterreading.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-meterreading/marketdate-meterreading-detail.component.ts